import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { withTranslation } from 'react-i18next'

import Section from './Section'

import './styles.scss'

const baseClass = 'onboarding-protracks-levels'

const ProtracksLevels = ({ t, newProTrackLevels, previousProTracks, currentProTrack }) => (
  <div className={baseClass}>
    <Section
      title={t('Select a New ProTrack')}
      subtitle={t('These are a series of personal and professional habit forming activities you receive daily')}
      newProTrackLevels={newProTrackLevels}
      previousProTracks={previousProTracks}
      currentProTrack={currentProTrack}
    />
  </div>
)

ProtracksLevels.propTypes = {
  newProTrackLevels: ImmutablePropTypes.list.isRequired,
}

export default withTranslation('user')(ProtracksLevels)
